export default "__VITE_ASSET__WHYAxEUE__"